import { DigitalCertificateDefaultModule } from './digital-certificate-default/digital-certificate-default.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { HomeEnterpriseRoutingModule } from "./home-enterprise-routing.module";
import { HomeEnterpriseComponent } from "./home-enterprise.component";
import { EnterpriseModule } from "./enterprise/enterprise.module";
import { MainComponent } from "./main/main.component";
import { CustomerModule } from "./customer/customer.module";
import { BranchModule } from "./branch/branch.module";
import { ContentIntroduceComponent } from "./main/content-introduce/content-introduce.component";
import { SlideBarComponent } from "./main/slide-bar/slide-bar.component";
import { UserModule } from "./user/user.module";
import { UserGroupModule } from "./user-group/user-group.module";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatInputModule,
  MatButtonModule,
  MatSelectModule,
  MatCardModule,
  MatAutocompleteModule,
  MatIconModule,
  MatProgressBarModule,
  MatFormFieldModule,
  MatTooltipModule,
} from "@angular/material";
import { NgMatAutocompleteModule } from "src/app/shared/components/autocomplete/autocomplete.module";
import { DocumentTypeModule } from "./document-type/document-type.module";
import { DocumentModule } from "./document/document.module";
import { DigitalCertificateModule } from "./digital-certificate/digital-certificate.module";
import { NotifyModule } from "./notify/notify.module";
import { MaterialModule } from "src/app/core/material";
import { HighchartsChartModule } from "highcharts-angular";
import { AnalysisReportModule } from "./analysis-report/analysis-report.module";
import { AnalysisReportComponent } from "../home-enterprise/analysis-report/analysis-report.component";
import { ReportModule } from "./report/report.module";
import { UserConfigModule } from './user-config/user-config.module';
import { DocumentManagementModule } from "./document-management/document-management.module";
import { GeneralCategoryModule } from "./general-category/general-category.module";
import { ContractLotModule } from "./contract-lot/contract-lot.module";
import { ProcedureManagementComponent } from './procedure-management/procedure-management.component';
import { DepartmentModule } from './department/department.module';
import { GroupCustomerModule } from './group-customer/group-customer.module';
import {EnterpriseConfigModule} from './enterprise-config/enterprise-config.module';
import { EnterpriseNotificationModule } from './enterprise-notification/enterprise-notification.module';
import { LinkGoogleAccountModule } from './link-google-account/link-google-account.module';
import { EnterpriseActionLogComponent } from './enterprise-action-log/enterprise-action-log.component';
import { EnterpriseActionLogModule } from './enterprise-action-log/enterprise-action-log.module';
import {LinkAccountModule} from './link-account/link-account.module';
import { LaborUtilizationReportModule } from './labor-utilization-report/labor-utilization-report.module';
import {ContractDigitizationMohaModule} from './contract-digitzation-moha/contract-digitzation-moha.module'

import { MenuExportReportModule } from './menu-export-report/menu-export-report.module';
import { AlertConfigDataHDLDComponent } from 'src/app/shared/components/alert-config-data-hdld/alert-config-data-hdld.component';
import { ContractLotMohaModule } from './contract-lot-moha/contract-lot-moha.module';
import { ContractLotStandardizedModule } from './contract-lot-standardized/contract-lot-standardized.module';

@NgModule({
  declarations: [
    HomeEnterpriseComponent,
    SlideBarComponent,
    ContentIntroduceComponent,
    MainComponent,
    AnalysisReportComponent,
    ProcedureManagementComponent,
    AlertConfigDataHDLDComponent
  ],
  imports: [
  MatFormFieldModule,
    CommonModule,
    HomeEnterpriseRoutingModule,
    EnterpriseModule,
    CustomerModule,
    BranchModule,
    UserModule,
    DocumentModule,
    UserGroupModule,
    DocumentTypeModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    NotifyModule,
    DigitalCertificateModule,
    MaterialModule,
    DigitalCertificateModule,
    HighchartsChartModule,
    AnalysisReportModule,
    ReportModule,
    DocumentManagementModule,
    GeneralCategoryModule,
    DigitalCertificateDefaultModule,
    ContractLotModule,
    ContractLotMohaModule,
    ContractLotStandardizedModule,
    UserConfigModule,
    DepartmentModule,
    MatTooltipModule,
    EnterpriseConfigModule,
    GroupCustomerModule,
    EnterpriseNotificationModule,
    LinkGoogleAccountModule,
    LinkAccountModule,
    EnterpriseActionLogModule,
    LaborUtilizationReportModule,
    ContractDigitizationMohaModule,
    LaborUtilizationReportModule,
    EnterpriseActionLogModule,
    MenuExportReportModule
  ],
  exports: [SlideBarComponent, TranslateModule, DocumentManagementModule],
  entryComponents: [AlertConfigDataHDLDComponent]
})
export class HomeEnterpriseModule {}
